//导出所有的根 actions 操作

export default {
  showMsgModal({commit}, settings){
    commit('setModal', settings);
    commit('showMsgModal', true);
    if(settings.autoClose){
      setTimeout(function(){
        commit('showMsgModal', false);
      }, 1000)
    }
  },
  updateUser({commit}, user){
    commit('updateUser', user);
    let IP360 = {user};
    localStorage.setItem("IP360", JSON.stringify(IP360));
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js